import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasDiscreteUserField extends EditorEligibilityRule {
  className = 'HasDiscreteUserField';
  operatorName = 'hasUserField';

  userField: string;
  userFieldCategories: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.userField = obj?.userField ?? null;
    this.userFieldCategories = obj?.userFieldCategories ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return (legacyEligibilityRules?.args?.[1]?.op === 'pick' || legacyEligibilityRules?.args?.[1]?.op === 'get')
      && legacyEligibilityRules?.args?.[1]?.args?.[0]?.op === 'fetchUser';
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    return new this({
      userField: legacyEligibilityRules.args[1].options.value,
      userFieldCategory: legacyEligibilityRules.args[0].options.value
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      userField: serializedValues.userField,
      userFieldCategories: serializedValues.userFieldCategories
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      userField: [{ value: null, disabled: true }],
      userFieldCategories: [{ value: [], disabled: true }],
    };
  }

  createCopy(): EditorEligibilityRuleHasDiscreteUserField {
    return new EditorEligibilityRuleHasDiscreteUserField({
      id: this.id,
      userField: this.userField,
      userFieldCategories: this.userFieldCategories
    });
  }

  getUserFieldName(discreteUserFieldNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[]): string {
    if (this.userField === null) { return ''; }
    return discreteUserFieldNamesWithCategoryNames
      .find(userFieldNameWithCategoryNames => userFieldNameWithCategoryNames.id === this.userField)?.name ?? $localize `Not valid`;
  }

  getUserFieldCategoriesAsString(
    discreteUserFieldNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[]
  ): string {
    if (this.userField === null || this.userFieldCategories.length === 0) { return ''; }
    const categoryNames = discreteUserFieldNamesWithCategoryNames
      .find(userFieldNameWithCategoryNames => userFieldNameWithCategoryNames.id === this.userField)?.categoryNames ?? [];
    return this.userFieldCategories
      .map(userFieldCategory =>
        categoryNames.find(categoryName => categoryName.id === userFieldCategory) ?? { id: userFieldCategory, name: $localize `Not valid` }
      )
      .map(categoryName => categoryName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      userField: [this.userField],
      userFieldCategories: [this.userFieldCategories]
    };
  }

  getSerializedValues(): any {
    return {
      userFieldType: 'discrete',
      userField: this.userField,
      userFieldCategories: this.userFieldCategories
    };
  }
}
